<template>
  <div class="background-card">
    <div class="header">
      <div class="header-name">{{ item.name }}</div>
      <div class="header-details" :class="`${item.textSize.value}-text`">
        <div class="type-rarity-attunement">
          <span>{{ item.type }}<span v-if="item.subType"> ({{ item.subType }})</span>, </span>
          <span>{{ item.rarity }} </span>
          <span v-if="item.requiresAttunement">(requer sintonização)</span>
        </div>
        <div class="description" v-html="itemDescription"></div>
      </div>
    </div>
    <div class="body">
      <div class="body-heading">
        <span>Mecânicas</span>
      </div>
      <div class="body-content" :class="`${item.textSize.value}-text`">
        <div class="effect">
          <div class="effect-description" v-html="itemEffects"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import marked from 'marked'

  export default {
    name: 'BackgroundCard',
    props: {
      item: {
        type: Object
      }
    },
    computed: {
      itemDescription () {
        return this.getMarkdownText(this.item.description)
      },
      itemEffects () {
        return this.getMarkdownText(this.item.effects)
      }
    },
    methods: {
      getMarkdownText (text) {
        return marked(text, { sanitize: true })
      }
    }
  }
</script>

<style lang="scss" scoped>
  $base-size: 16px;
  $half-size: ($base-size / 2);
  $header-subtitle-size: 40px;
  $header-title-size: 48px;
  $highlight-color: #5b0f18;

  @mixin flex-column {
    display: flex;
    flex-direction: column;
  }

  @mixin title ($width: 4px) {
    border-bottom: $width solid $highlight-color;
    color: $highlight-color;
    font-family: "Mr Eaves Small Caps";
  }

  @mixin text-sizes {
    $text-sizes: 'medium', 'small', 'tiny';
    $base-text-size: 30px;
    $increase-text-size-ratio: 2px;

    @each $size in $text-sizes {
      $index: index($text-sizes, $size) - 1;
      $text-size: $base-text-size - ($index * $increase-text-size-ratio);

      &.#{$size}-text {
        font-size: $text-size;
        line-height: $text-size + 4px;
      }
    }
  }

  @mixin description-text {
    @include text-sizes;
  }

  @mixin text-shadow-white {
    text-shadow: 1px 1px $base-size white;
  }

  .background-card {
    @include flex-column;
    background-image: url("../../public/assets/background.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: $base-size;
    box-sizing: border-box;
    font-size: 28px;
    height: 100%;
    line-height: 28px;
    padding: $half-size $base-size;
    width: 100%;

    .header {
      @include flex-column;
      height: auto;
      max-height: 50%;
      top: 0;

      .header-name {
        @include title;
        align-self: center;
        font-size: $header-title-size;
        height: auto;
        line-height: $header-title-size;
        margin-bottom: $half-size;
        width: 100%;
      }

      .header-details {
        @include description-text;
        @include flex-column;
        flex-grow: 1;
        height: 100%;

        .type-rarity-attunement {
          color: #333;
          font-style: italic;
          font-weight: bold;
        }

        .description {
          flex: 1;
          hyphens: auto;
          overflow: hidden;
        }
      }

      .header-name,
      .header-details .type-rarity-attunement,
      .header-details .description {
        padding: $half-size 0;
      }
    }

    .body {
      @include flex-column;
      flex-grow: 1;

      .body-heading {
        @include title($width: 1px);
        font-size: $header-subtitle-size;
        height: auto;
        line-height: $header-subtitle-size + $half-size;
        margin-bottom: $half-size;
        width: 100%;
      }

      .body-content {
        @include description-text;
        flex: 1;
        overflow: hidden;

        .effect .effect-description {
          padding: $base-size 0;
        }
      }
    }
  }
</style>